import React, {ReactElement} from 'react';
import BaseFileLoader, {FileResult} from './BaseFileLoader';

interface NblFileLoaderProps {
    onLoad: (files: FileResult[]) => void;
    multipleFiles?: boolean;
    child?: JSX.Element;
    inputRef?: React.RefObject<HTMLInputElement>;
}

function NblFileLoader(props: NblFileLoaderProps): ReactElement {
    const {onLoad, multipleFiles = false, child, inputRef} = props;

    const getButton = (): JSX.Element => <></>;

    return (
        <BaseFileLoader
            inputRef={inputRef}
            accept=".nbl"
            readAs="text"
            fileTypeCheck={(file) => file.name.endsWith('.nbl')}
            onLoad={onLoad}
            type="nbl"
            multipleFiles={multipleFiles}
            child={child || getButton()}
        />
    );
}

export default NblFileLoader;
